import { render, staticRenderFns } from "./add-company-info.vue?vue&type=template&id=4d4f65e3&scoped=true"
import script from "./add-company-info.vue?vue&type=script&lang=js"
export * from "./add-company-info.vue?vue&type=script&lang=js"
import style0 from "./add-company-info.vue?vue&type=style&index=0&id=4d4f65e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4f65e3",
  null
  
)

export default component.exports